<template>
  <footer class="footer-wrap pt-100 hide">
  </footer>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "MainFooter",
});
</script>

<style lang="scss" scoped>
.footer-wrap {
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  .footer-widget {
    margin-bottom: 30px;
    .footer-widget-title {
      color: #f3f4f6;
      font-size: 18px;
      font-weight: 600;
      line-height: 16px;
      margin-bottom: 23px;
    }
    .footer-logo {
      display: block;
      margin-bottom: 28px;
    }
    .comp-desc {
      color: #d1d5db;
      line-height: 1.6;
    }
    .footer-menu {
      li {
        margin-bottom: 14px;
        a {
          color: #9ca3af;
          line-height: 16px;
          transition: color 0.3s ease;

          &:hover {
            color: #f3f4f6;
          }
        }
      }
    }
    .address-item-wrap {
      margin-top: 30px;
      .address-item {
        margin-bottom: 18px;
        &:last-child {
          margin-bottom: 0;
        }
        h6 {
          color: #e5e7eb;
          font-size: 16px;
          font-weight: 500;
          line-height: 16px;
          margin-bottom: 14px;
        }
        p {
          color: #9ca3af;
          line-height: 1.6;
        }
      }
    }
  }
  .copyright-text {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    text-align: center;
    padding: 35px 0;
    color: #6b7280;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0.32px;
    margin: 0;
    span,
    a {
      color: #f3f4f6;
      font-weight: 600;
      transition: color 0.3s ease;
      &:hover {
        color: #e5e7eb;
      }
    }
    i {
      position: relative;
      margin-right: 1px;
      top: -1px;
    }
  }
}

@media only screen and (max-width: 767px) {
  .footer-wrap {
    .footer-widget {
      .footer-widget-title {
        margin-bottom: 18px;
      }
      .footer-logo {
        margin-bottom: 15px;
      }
      .footer-menu {
        li {
          margin-bottom: 6px;
          a {
            font-size: 14px;
          }
        }
      }
      .address-item-wrap {
        margin-top: 23px;
        .address-item {
          h6 {
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}
@media only screen and (min-width: 1200px) {
  .footer-wrap {
    .footer-widget {
      .footer-widget-title {
        margin-top: 8px;
      }
    }
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1399px) {
  .footer-wrap {
    .row {
      & > div {
        &:nth-child(2) {
          padding-left: 55px;
        }
      }
    }
  }
}
@media only screen and (min-width: 1400px) {
  .footer-wrap {
    .row {
      & > div {
        &:nth-child(2) {
          padding-left: 85px;
        }
        &:nth-child(3) {
          margin-left: -10px;
        }
        &:nth-child(4) {
          padding-left: 55px;
        }
      }
    }
  }
}
</style>